import { render } from "./Bracket.vue?vue&type=template&id=03aa32d2&scoped=true"
import script from "./Bracket.vue?vue&type=script&lang=js"
export * from "./Bracket.vue?vue&type=script&lang=js"

import "./Bracket.vue?vue&type=style&index=0&id=03aa32d2&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03aa32d2"]])

export default __exports__